// @flow
import { superpathjoin } from 'superpathjoin';

import { selectCartUUID } from '@gandi/cart';
import { selectCurrentId } from '@gandi/redux-sharing';

import { selectAdminURL, selectAdminBillingUrl } from '../../modules/config';
import type { FullState } from '../../types';

export const selectAdminShsUrl = (state: FullState): string =>
  superpathjoin(selectAdminURL(state), 'simplehosting', selectCurrentId(state));

export const selectOverviewUrl = (state: FullState): string => {
  const cartId = selectCartUUID(state);
  return cartId ? `/cart/${cartId}/overview` : '/cart/overview';
};
export const selectCreateUrl = (
  state: FullState,
  { productId }: { productId: string, ... },
): string => {
  const cartId = selectCartUUID(state);
  if (productId) {
    return superpathjoin('simplehosting', 'create', cartId, productId);
  }
  return '';
};
export const selectOrdersListUrl = (state: FullState): string => {
  const baseUrl = selectAdminBillingUrl(state);
  return superpathjoin(baseUrl, 'orders');
};
